import { lazy } from 'react';

const registry = {
    hero: lazy(() => import('./Sections/HeroSection')),
    gallery: lazy(() => import('./Sections/CarouselSection')),
    careers: lazy(() => import('./Sections/CareersSection')),
    about: lazy(() => import('./Sections/AboutSection')),
    locations: lazy(() => import('./Sections/LocationsSection')),
    contact: lazy(() => import('./Sections/ContactSection')),
    cta: lazy(() => import('./Sections/CtaBanner')),
    text: lazy(() => import('./Sections/TextSection')),
    video: lazy(() => import('./Sections/VideoSection')),
    testimonials: lazy(() => import('./Sections/TestimonialsSection')),
    faq: lazy(() => import('./Sections/FaqSection')),
    separator: lazy(() => import('./Sections/SeparatorSection')),
    stats: lazy(() => import('./Sections/StatsSection')),
    logos: lazy(() => import('./Sections/LogosSection')),
    features: lazy(() => import('./Sections/FeaturesSection')),
    services: lazy(() => import('./Sections/ServicesSection')),
    pricing: lazy(() => import('./Sections/PricingSection')),
    blog: lazy(() => import('./Sections/BlogSection')),
    promo: lazy(() => import('./Sections/PromoSection')),
    team: lazy(() => import('./Sections/TeamSection')),
    countdown: lazy(() => import('./Sections/CountdownSection')),
    marquee: lazy(() => import('./Sections/MarqueeTextSection')),
    comparison: lazy(() => import('./Sections/ComparisonSection')),
    form: lazy(() => import('./Sections/FormSection')),
    process: lazy(() => import('./Sections/ProcessSection')),
    map: lazy(() => import('./Sections/MapSection')),
    sticky_bar: lazy(() => import('./Sections/StickyBarSection')),
    popup: lazy(() => import('./Sections/PopupSection')),
    programs: lazy(() => import('./Sections/ProgramsSection')),
    media_gallery: lazy(() => import('./Sections/MediaGallerySection')),
    partners: lazy(() => import('./Sections/PartnersSection')),
    download: lazy(() => import('./Sections/DownloadSection')),
    areas: lazy(() => import('./Sections/AreasSection')),
    image_marquee: lazy(() => import('./Sections/ImageMarqueeSection')),
    before_after: lazy(() => import('./Sections/BeforeAfterSection')),
    accordion_gallery: lazy(() => import('./Sections/AccordionGallerySection')),
    newsletter: lazy(() => import('./Sections/NewsletterSection')),
    badges: lazy(() => import('./Sections/BadgesSection')),
    spotlight: lazy(() => import('./Sections/SpotlightSection')),
    social_proof: lazy(() => import('./Sections/SocialProofSection')),
    quote: lazy(() => import('./Sections/QuoteSection')),
    bento_grid: lazy(() => import('./Sections/BentoGridSection')),
    icon_grid: lazy(() => import('./Sections/IconGridSection')),
    events: lazy(() => import('./Sections/EventsSection')),
    menu: lazy(() => import('./Sections/MenuSection')),
    portfolio: lazy(() => import('./Sections/PortfolioSection')),
    schedule: lazy(() => import('./Sections/ScheduleSection')),
    product: lazy(() => import('./Sections/ProductSection')),
    timeline: lazy(() => import('./Sections/TimelineSection')),
    embed: lazy(() => import('./Sections/EmbedSection')),
    catalog: lazy(() => import('./Sections/CatalogSection')),
    hours: lazy(() => import('./Sections/HoursSection')),
    reviews: lazy(() => import('./Sections/ReviewsSection')),
    split: lazy(() => import('./Sections/SplitSection')),
    parallax: lazy(() => import('./Sections/ParallaxSection')),
    banner_slider: lazy(() => import('./Sections/BannerSliderSection')),
    flip_cards: lazy(() => import('./Sections/FlipCardsSection')),
    gallery_tabs: lazy(() => import('./Sections/GalleryTabsSection')),
    animated_text: lazy(() => import('./Sections/AnimatedTextSection')),
    trust_bar: lazy(() => import('./Sections/TrustBarSection')),
    data_table: lazy(() => import('./Sections/DataTableSection')),
    app_download: lazy(() => import('./Sections/AppDownloadSection')),
    tabs_content: lazy(() => import('./Sections/TabsContentSection')),
    columns: lazy(() => import('./Sections/ColumnsSection')),
    instagram: lazy(() => import('./Sections/InstagramSection')),
    chat_preview: lazy(() => import('./Sections/ChatPreviewSection')),
    dashboard_preview: lazy(() => import('./Sections/DashboardPreviewSection')),
    feature_cards_numbered: lazy(() => import('./Sections/FeatureCardsNumberedSection')),
    app_mockup: lazy(() => import('./Sections/AppMockupSection')),
    pricing_calculator: lazy(() => import('./Sections/PricingCalculatorSection')),
    quiz: lazy(() => import('./Sections/QuizSection')),
    booking: lazy(() => import('./Sections/BookingSection')),
    testimonial_video: lazy(() => import('./Sections/TestimonialVideoSection')),
    faq_contact: lazy(() => import('./Sections/FaqContactSection')),
    product_grid: lazy(() => import('./Sections/ProductGridSection')),
    cookie_consent: lazy(() => import('./Sections/CookieConsentSection')),
    interactive_map: lazy(() => import('./Sections/InteractiveMapSection')),
    awards: lazy(() => import('./Sections/AwardsSection')),
    job_application: lazy(() => import('./Sections/JobApplicationSection')),
    notification_bar: lazy(() => import('./Sections/NotificationBarSection')),
    loyalty_program: lazy(() => import('./Sections/LoyaltyProgramSection')),
    recipe: lazy(() => import('./Sections/RecipeSection')),
    exit_intent: lazy(() => import('./Sections/ExitIntentSection')),
    team_culture: lazy(() => import('./Sections/TeamCultureSection')),
    size_guide: lazy(() => import('./Sections/SizeGuideSection')),
    media_kit: lazy(() => import('./Sections/MediaKitSection')),
    affiliate_disclosure: lazy(() => import('./Sections/AffiliateDisclosureSection')),
    scroll_story: lazy(() => import('./Sections/ScrollStorySection')),
    integrations_grid: lazy(() => import('./Sections/IntegrationsGridSection')),
    case_study: lazy(() => import('./Sections/CaseStudySection')),
    hotspot_image: lazy(() => import('./Sections/HotspotImageSection')),
    changelog: lazy(() => import('./Sections/ChangelogSection')),
    waitlist: lazy(() => import('./Sections/WaitlistSection')),
    number_ticker: lazy(() => import('./Sections/NumberTickerSection')),
    pricing_toggle: lazy(() => import('./Sections/PricingToggleSection')),
    comparison_table: lazy(() => import('./Sections/ComparisonTableSection')),
    floating_cta: lazy(() => import('./Sections/FloatingCtaSection')),
    content_accordion: lazy(() => import('./Sections/ContentAccordionSection')),
    social_feed: lazy(() => import('./Sections/SocialFeedSection')),
    kinetic_text: lazy(() => import('./Sections/KineticTextSection')),
    aurora: lazy(() => import('./Sections/AuroraSection')),
    guarantee: lazy(() => import('./Sections/GuaranteeSection')),
    split_cta: lazy(() => import('./Sections/SplitCtaSection')),
    cursor_spotlight: lazy(() => import('./Sections/CursorSpotlightSection')),
    blob_features: lazy(() => import('./Sections/BlobFeaturesSection')),
    magnetic_cards: lazy(() => import('./Sections/MagneticCardsSection')),
    testimonial_stack: lazy(() => import('./Sections/TestimonialStackSection')),
    distortion_grid: lazy(() => import('./Sections/DistortionGridSection')),
    grid_break: lazy(() => import('./Sections/GridBreakSection')),
    layered_reveal: lazy(() => import('./Sections/LayeredRevealSection')),
    use_cases: lazy(() => import('./Sections/UseCasesSection')),
    liquid_glass: lazy(() => import('./Sections/LiquidGlassSection')),
    particle_section: lazy(() => import('./Sections/ParticleSection')),
    svg_path: lazy(() => import('./Sections/SvgPathSection')),
    scroll_split: lazy(() => import('./Sections/ScrollSplitSection')),
    text_video_mask: lazy(() => import('./Sections/TextVideoMaskSection')),
    video_scrub: lazy(() => import('./Sections/VideoScrubSection')),
    product_demo: lazy(() => import('./Sections/ProductDemoSection')),
    error_404: lazy(() => import('./Sections/Error404Section')),
    activity_feed: lazy(() => import('./Sections/ActivityFeedSection')),
    metric_dashboard: lazy(() => import('./Sections/MetricDashboardSection')),
    playbook_cards: lazy(() => import('./Sections/PlaybookCardsSection')),
    audience_cards: lazy(() => import('./Sections/AudienceCardsSection')),
    multi_step_form: lazy(() => import('./Sections/MultiStepFormSection')),
    testimonial_receipts: lazy(() => import('./Sections/TestimonialReceiptsSection')),
    problem_solution: lazy(() => import('./Sections/ProblemSolutionSection')),
    advisor_cta: lazy(() => import('./Sections/AdvisorCtaSection')),
    persona_grid: lazy(() => import('./Sections/PersonaGridSection')),
    feature_carousel: lazy(() => import('./Sections/FeatureCarouselSection')),
    problem_grid: lazy(() => import('./Sections/ProblemGridSection')),
    cross_links: lazy(() => import('./Sections/CrossLinksSection')),
    brand_portfolio: lazy(() => import('./Sections/BrandPortfolioSection')),
    values_grid: lazy(() => import('./Sections/ValuesGridSection')),
    impact_metrics: lazy(() => import('./Sections/ImpactMetricsSection')),
    social_proof_live: lazy(() => import('./Sections/SocialProofLiveSection')),
    custom: lazy(() => import('./Sections/CustomSection')),
};

export default registry;
